import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const Reviews = ({ valueProps, reviews }) => (
  <section className="section bg-blue-gradient text-white">
    <div className="container">
      <div className="mb-50px d-block d-lg-none text-center">
        <h1 className="mb-30px">Customer reviews</h1>
        <div>Here&apos;s what some of our customers are saying about Subscribe By Usage</div>
      </div>
      <div className="row d-flex flex-column-reverse flex-lg-row">
        <div className="col-12 col-lg-5 d-flex flex-column justify-content-between">
          <div className="mb-30px d-none d-lg-block">
            <h1 className="mb-30px">Customer reviews</h1>
            <div>Here&apos;s what some of our customers are saying about Subscribe By Usage</div>
          </div>
          <div className="gap-20px d-flex flex-column">
            {valueProps.map(({ title, description }, key) => (
              <div className="stat-wrapper d-flex" key={key}>
                <div>
                  <div className="stat-name">{title}</div>
                  <div className="stat-description">{description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-12 col-lg-7 reviews d-flex flex-column flex-lg-row align-items-center">
          <div className="carousel-button d-none d-lg-flex">
            <button className="carousel-control-prev" type="button" data-target="#carousel-reviews" data-slide="prev">
              <img
                src="https://bottomless.imgix.net/landing-generic-v2/icon-arrow-left-white.png?auto=compress,format&h=30"
                srcSet="
                    https://bottomless.imgix.net/landing-generic-v2/icon-arrow-left-white.png?auto=compress,format&h=30 1x,
                    https://bottomless.imgix.net/landing-generic-v2/icon-arrow-left-white.png?auto=compress,format&h=60 2x
                  "
                alt="<-"
                width="30"
                height="30"
              />
              <span className="sr-only">Previous</span>
            </button>
          </div>
          <div className="carousel slide w-100" id="carousel-reviews" data-ride="carousel">
            <div className="carousel-inner">
              {reviews.map(({ text, author, source, image }, key) => (
                <div className={classNames('carousel-item', { active: key === 0 })} key={key}>
                  <div className="rounded border border-white p-3 mx-3 mx-md-4 review bg-primary">
                    <div className="mb-50px font-italic review-text">“{text}”</div>
                    <div>
                      <div className="font-weight-bold">{author}</div>
                      <div>{source}</div>
                    </div>
                  </div>
                  <img
                    srcSet={`${image}?auto=compress,format&h=486 1x, ${image}?auto=compress,format&h=972 2x`}
                    src={`{$image}?auto=compress,format&h=486`}
                    className="d-block w-100 rounded img-fluid"
                    height="486"
                    width="616"
                    alt={`Review ${key + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="carousel-button d-none d-lg-flex justify-content-end">
            <button className="carousel-control-next" type="button" data-target="#carousel-reviews" data-slide="next">
              <img
                src="https://bottomless.imgix.net/landing-generic-v2/icon-arrow-right-white.png?auto=compress,format&h=30"
                srcSet="
                    https://bottomless.imgix.net/landing-generic-v2/icon-arrow-right-white.png?auto=compress,format&h=30 1x,
                    https://bottomless.imgix.net/landing-generic-v2/icon-arrow-right-white.png?auto=compress,format&h=60 2x
                  "
                alt="->"
                width="30"
                height="30"
              />
              <span className="sr-only">Next</span>
            </button>
          </div>
          <div className="d-flex d-lg-none pt-4 mb-50px gap-20px">
            <div className="carousel-button d-flex justify-content-center">
              <button className="carousel-control-prev" type="button" data-target="#carousel-reviews" data-slide="prev">
                <img
                  src="https://bottomless.imgix.net/landing-generic-v2/icon-arrow-left-white.png?auto=compress,format&h=20"
                  srcSet="
                      https://bottomless.imgix.net/landing-generic-v2/icon-arrow-left-white.png?auto=compress,format&h=20 1x,
                      https://bottomless.imgix.net/landing-generic-v2/icon-arrow-left-white.png?auto=compress,format&h=40 2x
                    "
                  alt="<-"
                  width="20"
                  height="20"
                />
                <span className="sr-only">Previous</span>
              </button>
            </div>
            <div className="carousel-button d-flex justify-content-center">
              <button className="carousel-control-next" type="button" data-target="#carousel-reviews" data-slide="next">
                <img
                  src="https://bottomless.imgix.net/landing-generic-v2/icon-arrow-right-white.png?auto=compress,format&h=20"
                  srcSet="
                      https://bottomless.imgix.net/landing-generic-v2/icon-arrow-right-white.png?auto=compress,format&h=20 1x,
                      https://bottomless.imgix.net/landing-generic-v2/icon-arrow-right-white.png?auto=compress,format&h=40 2x
                    "
                  alt="->"
                  width="20"
                  height="20"
                />
                <span className="sr-only">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

Reviews.propTypes = {
  valueProps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      author: PropTypes.string.isRequired,
      source: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    })
  ).isRequired,
};
